export const ENTERPRISE_COLORS = {
  primary: "#1976d2",
  primaryHover: "#156ac1",
  primarySoft: "#E8F0FF",
  text: "#191C1E",
  secondaryText: "#515F74",
  border: "#C3C5D7",
  background: "#FFFFFF",
  pageBackground: "#F8FAFC",
  danger: "#C62828",
  dangerBorder: "#E7B8B8",
  dangerBackground: "#FFF5F5",
  disabled: "#94A3B8",
};

export const enterprisePageSx = {
  width: "100%",
  maxWidth: "100%",
  mx: "auto",
  px: { xs: 2, sm: 4 },
  py: { xs: 3, sm: 4 },
  backgroundColor: ENTERPRISE_COLORS.background,
};

export const enterpriseHeadingSx = {
  fontFamily: '"Hanken Grotesk", "GilroyBold", sans-serif',
  fontWeight: 700,
  fontSize: { xs: "30px", sm: "36px" },
  lineHeight: 1.15,
  color: ENTERPRISE_COLORS.text,
};

export const enterpriseSectionTitleSx = {
  fontFamily: '"Hanken Grotesk", "GilroySemiBold", sans-serif',
  fontWeight: 600,
  fontSize: "20px",
  lineHeight: 1.3,
  color: ENTERPRISE_COLORS.text,
};

export const enterpriseBodyTextSx = {
  fontFamily: 'Inter, "GilroyMedium", sans-serif',
  fontSize: "16px",
  lineHeight: 1.5,
  color: ENTERPRISE_COLORS.text,
};

export const enterpriseSupportingTextSx = {
  fontFamily: 'Inter, "GilroyMedium", sans-serif',
  fontSize: "14px",
  lineHeight: 1.5,
  color: ENTERPRISE_COLORS.secondaryText,
};

export const enterpriseBackButtonSx = {
  minWidth: "106px",
  minHeight: "40px",
  px: 2.25,
  borderRadius: "4px",
  textTransform: "none",
  backgroundColor: "#2F8FD8",
  color: "#FFFFFF",
  boxShadow: "none",
  fontFamily: 'Inter, "GilroySemiBold", sans-serif',
  fontSize: "14px",
  fontWeight: 600,
  "&:hover": {
    backgroundColor: "#227CC0",
    boxShadow: "none",
  },
};

export const enterprisePrimaryButtonSx = {
  minHeight: "44px",
  px: 3,
  borderRadius: "5px",
  textTransform: "none",
  backgroundColor: ENTERPRISE_COLORS.primary,
  color: "#FFFFFF",
  boxShadow: "none",
  fontFamily: "gilroySemibold",
  fontSize: "14px",
  
  "&:hover": {
    backgroundColor: ENTERPRISE_COLORS.primaryHover,
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: ENTERPRISE_COLORS.disabled,
    color: "#FFFFFF",
  },
};

export const enterpriseGhostButtonSx = {
  minHeight: "40px",
  px: 2.5,
  borderRadius: "4px",
  textTransform: "none",
  borderColor: ENTERPRISE_COLORS.border,
  color: ENTERPRISE_COLORS.text,
  boxShadow: "none",
  fontFamily: 'Inter, "GilroySemiBold", sans-serif',
  fontSize: "14px",
 
  "&:hover": {
    borderColor: ENTERPRISE_COLORS.primary,
    backgroundColor: ENTERPRISE_COLORS.primarySoft,
    boxShadow: "none",
  },
};

export const enterpriseDangerButtonSx = {
  ...enterpriseGhostButtonSx,
  borderColor: ENTERPRISE_COLORS.dangerBorder,
  color: ENTERPRISE_COLORS.danger,
  backgroundColor: ENTERPRISE_COLORS.dangerBackground,
  "&:hover": {
    borderColor: ENTERPRISE_COLORS.danger,
    backgroundColor: "#FFE7E7",
  },
};

export const enterpriseStatusChipSx = {
  borderRadius: "999px",
  border: `1px solid ${ENTERPRISE_COLORS.border}`,
  backgroundColor: "#FFFFFF",
  color: ENTERPRISE_COLORS.secondaryText,
  fontFamily: 'Inter, "GilroyMedium", sans-serif',
  fontSize: "14px",
  fontWeight: 500,
  height: "38px",
  "& .MuiChip-label": {
    px: 2,
  },
};

export const getEnterpriseUploadZoneSx = (isActive = false) => ({
  width: "100%",
  maxWidth: "896px",
  minHeight: "134px",
  display: "flex",
  alignItems: { xs: "flex-start", md: "center" },
  justifyContent: "space-between",
  flexDirection: { xs: "column", md: "row" },
  gap: 2,
  px: { xs: 3, sm: 5 },
  py: { xs: 3, sm: 4 },
  border: `1px dashed ${isActive ? ENTERPRISE_COLORS.primary : ENTERPRISE_COLORS.border}`,
  borderRadius: "8px",
  backgroundColor: "#FFFFFF",
  cursor: "pointer",
  transition: "border-color 0.2s ease, background-color 0.2s ease",
  "&:hover": {
    borderColor: ENTERPRISE_COLORS.primary,
  },
});

export const enterpriseBrowseButtonSx = {
  minWidth: "120px",
  minHeight: "40px",
  px: 2.5,
  borderRadius: "4px",
  textTransform: "none",
  backgroundColor: "#2F8FD8",
  color: "#FFFFFF",
  boxShadow: "none",
  fontFamily: 'Inter, "GilroySemiBold", sans-serif',
  fontSize: "14px",
  fontWeight: 600,
  "&:hover": {
    backgroundColor: "#227CC0",
    boxShadow: "none",
  },
};
